export default __webpack_public_path__ + "static/project-slide-1-415-700-cf12efcab611e44e4eeaadb30aa46eb0.webp";